import { schema } from 'normalizr';

export const documentSchema = new schema.Entity('documents');
export const auditLogEntrySchema = new schema.Entity('auditLogEntries');
export const entitySchema = new schema.Entity('entities');
